// Persistent storage (IMPLEMENTATION §2.9 "Save": `navigator.storage.persist()` only in a secure context).
// Asks the browser not to evict the save under storage pressure (Safari's 7-day rule does not apply to a
// Home Screen app anyway). Chrome / Safari grant or deny it heuristically without a prompt. The LAN dev
// server (http) is not a secure context: nothing is requested there.

export type PersistResult = 'granted' | 'denied' | 'insecure' | 'unsupported' | 'error';

interface StorageManagerLike {
  persist?: () => Promise<boolean>;
  persisted?: () => Promise<boolean>;
}

export async function requestPersistence(win: {
  isSecureContext: boolean;
  navigator: { storage?: StorageManagerLike };
}): Promise<PersistResult> {
  if (!win.isSecureContext) return 'insecure';
  const sm = win.navigator.storage;
  if (!sm || typeof sm.persist !== 'function') return 'unsupported';
  try {
    if (typeof sm.persisted === 'function' && (await sm.persisted())) return 'granted';
    return (await sm.persist()) ? 'granted' : 'denied';
  } catch {
    return 'error';
  }
}
